// Shared transition catalog — consumed by the Transitions page (browse /
// publish) and the publish-companion pickers in the playlist/layout create
// dialogs. A transition is a per-screen setting persisted on the backend
// (Screen.display_settings.transition) and applied by the players between
// content items; "publishing" one calls POST /transitions/publish.
export type Transition = { key: string; name: string; category: string; anim: string }

// `default` is the recommended baseline — a hard CUT (instant switch, no
// animation). It's first in the catalog and highlighted in the UI; screens with
// no explicit transition set use it. (There's no separate "Cut" entry — the
// default IS the cut.)
export const TRANSITIONS: Transition[] = [
  { key: 'default',     name: 'Default (Cut)',   category: 'Basic',  anim: 'tr-cut' },
  { key: 'fade',        name: 'Fade',            category: 'Fade',   anim: 'tr-fade' },
  { key: 'dissolve',    name: 'Cross Dissolve',  category: 'Fade',   anim: 'tr-dissolve' },
  { key: 'fade-black',  name: 'Fade to Black',   category: 'Fade',   anim: 'tr-fade' },
  { key: 'slide-left',  name: 'Slide Left',      category: 'Slide',  anim: 'tr-slide-left' },
  { key: 'slide-right', name: 'Slide Right',     category: 'Slide',  anim: 'tr-slide-right' },
  { key: 'slide-up',    name: 'Slide Up',        category: 'Slide',  anim: 'tr-slide-up' },
  { key: 'slide-down',  name: 'Slide Down',      category: 'Slide',  anim: 'tr-slide-down' },
  { key: 'push-left',   name: 'Push Left',       category: 'Push',   anim: 'tr-slide-left' },
  { key: 'push-right',  name: 'Push Right',      category: 'Push',   anim: 'tr-slide-right' },
  { key: 'zoom-in',     name: 'Zoom In',         category: 'Zoom',   anim: 'tr-zoom-in' },
  { key: 'zoom-out',    name: 'Zoom Out',        category: 'Zoom',   anim: 'tr-zoom-out' },
  { key: 'zoom-blur',   name: 'Zoom Blur',       category: 'Zoom',   anim: 'tr-zoom-blur' },
  { key: 'flip-h',      name: 'Flip Horizontal', category: 'Flip',   anim: 'tr-flip-h' },
  { key: 'flip-v',      name: 'Flip Vertical',   category: 'Flip',   anim: 'tr-flip-v' },
  { key: 'rotate',      name: 'Rotate',          category: 'Rotate', anim: 'tr-rotate' },
  { key: 'spin',        name: 'Spin',            category: 'Rotate', anim: 'tr-spin' },
  { key: 'wipe-left',   name: 'Wipe Left',       category: 'Wipe',   anim: 'tr-wipe-left' },
  { key: 'wipe-up',     name: 'Wipe Up',         category: 'Wipe',   anim: 'tr-wipe-up' },
  { key: 'cube',        name: 'Cube',            category: '3D',     anim: 'tr-cube' },
]

export const DEFAULT_TRANSITION_KEY = 'default'

// Speeds offered in the UI + sent to the backend.
export type TransitionSpeed = 'slow' | 'normal' | 'fast'
export const TRANSITION_SPEEDS: TransitionSpeed[] = ['slow', 'normal', 'fast']
